var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPrev = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 41,
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20.5718,
  r: 20,
  fill: "#F9F8F2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.7822 27.3958L16.22 20.5705L23.7822 13.7451",
  stroke: "#010B3B",
  strokeWidth: 1.35822
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgPrev);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prev.fe5536e8965b22106f3c93bafabcc9e4.svg";